
shadow$export("default",orgx.something_like_mdx_but_with_clojure_and_org_mode_for_my_personal_blog__part_i.component);
shadow$export("component",orgx.something_like_mdx_but_with_clojure_and_org_mode_for_my_personal_blog__part_i.component);